<template>
  <div class="carousel carouselOptimuz">
    <div
      v-for="(item, index) in items"
      :key="index"
      :class="getItemClass(index)"
      class="carousel__item"
    >
      <img :src="item.image" :alt="item.alt" />
      <!-- <div class="carousel__text">{{ item.text }}</div> -->
    </div>

    <div class="carousel__btns">
      <button id="leftBtn" class="carousel__btn" @click="moveLeft">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button id="rightBtn" class="carousel__btn" @click="moveRight">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 1,
    };
  },
  methods: {
    getItemClass(index) {
      if (index === this.currentIndex) {
        return "carousel__item--main";
      } else if (index === this.getPrevIndex()) {
        return "carousel__item--left";
      } else if (index === this.getNextIndex()) {
        return "carousel__item--right";
      }
      return "";
    },
    getPrevIndex() {
      return this.currentIndex === 0 ? this.items.length - 1 : this.currentIndex - 1;
    },
    getNextIndex() {
      return this.currentIndex === this.items.length - 1 ? 0 : this.currentIndex + 1;
    },
    moveRight() {
      this.currentIndex = this.getNextIndex();
    },
    moveLeft() {
      this.currentIndex = this.getPrevIndex();
    },
  },
};
</script>
